@if (isOpen) {
<section
  [class.extended]="menuIsExtended()"
  animate.enter="enter-sliding-in-animation"
  animate.leave="exit-sliding-out-animation"
>
  <wm-front-icon-button
    data-cy="close-filter"
    class="close-filter"
    (click)="closePanelAction()"
    [icon]="'close-sm'"
  >
  </wm-front-icon-button>
  <div>
    @for(configuration of configurations(); track configuration) {
    <wm-front-simple-filter
      [configuration]="configuration"
      [displayListInline]="true"
      [value]="values()?.[configuration.key!] ? (values()?.[configuration.key!]?.split(',') ?? []) : []"
      [reset]="reset"
      (changeEvent)="handleOptionPicked($event)"
    ></wm-front-simple-filter>
    }
  </div>
  <div
    class="reset"
    [class.disabled]="!filtersFacade.hasPersistentFilters$()"
    (click)="resetAllSelectedOptions()"
  >
    <p
      i18n="
        Button label | label for the reset button in the persistent filter
        component@@FiltersMenuResetActionButton"
    >
      Réinitialiser tous les filtres
    </p>
  </div>
</section>
<div
  class="background"
  animate.enter="enter-fading-in-animation"
  animate.leave="exit-fading-out-animation"
  [class.extended]="menuIsExtended()"
  (click)="closePanelAction()"
></div>
}
